<template>
  <div class="py-5 md:px-5">
    <PageHeader class="max-w-4xl" :title="`${$route.params.id ? 'Edit' : 'Create'} Depot`" :back-step="true" />
    
    <div class="max-w-4xl mx-auto">
      <div class="p-6 card">
        <Loading v-if="$route.params.id && loading" />
        <form @submit.prevent="upsertDepot()" v-else>
          <fieldset class="form-group">
            <label for="" class="form-label">
              Name
            </label>
            <input type="text" class="form-input" v-model="form.name">
          </fieldset>
          <fieldset class="form-group">
            <label for="" class="form-label">
              Area
            </label>
            <AreaSelect v-model="form.area_id" />
          </fieldset>
          <div class="border rounded-md">
            <fieldset class="p-6">
              <label class="flex items-center form-label">
                <toggle :value.sync="form.ptv_integration" class="mr-2" />
                Enable PTV Route Optimiser Integration
              </label>
            </fieldset>
            <Collapse :active="form.ptv_integration" :duration="200">
              <div class="grid px-6 py-3 gap-x-6 md:grid-cols-2">
                <fieldset class="form-group md:col-span-2">
                  <label for="" class="form-label">
                    URL
                  </label>
                  <select class="form-select" v-model="form.ptv_url">
                    <option value="webapi.za.routeoptimiser.net">
                      webapi.za.routeoptimiser.net
                    </option>
                    <option value="webapi.euwest.routeoptimiser.net">
                      webapi.euwest.routeoptimiser.net
                    </option>
                  </select>
                </fieldset>
                <fieldset class="form-group">
                  <label for="" class="form-label">
                    Username
                  </label>
                  <input type="text" class="form-input" v-model="form.ptv_username">
                </fieldset>
                <fieldset class="form-group">
                  <label for="" class="form-label">
                    Password
                  </label>
                  <input type="password" class="form-input" v-model="form.ptv_password">
                </fieldset>
                <fieldset class="form-group">
                  <label for="" class="form-label">
                    Project
                  </label>
                  <input type="text" class="form-input" v-model="form.ptv_project">
                </fieldset>
                <fieldset class="form-group">
                  <label for="" class="form-label">
                    Profile
                  </label>
                  <input type="text" class="form-input" v-model="form.ptv_profile">
                </fieldset>
              </div>
            </Collapse>
          </div>
          <button class="mt-4 btn btn-primary">
            {{ $route.params.id ? 'Save' : 'Create' }} Depot
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AreaSelect from '@/components/AreaSelect.vue'

export default {
  name: 'DepotForm',

  components: {
    AreaSelect
  },

  created () {
    if (this.$route.params.id) {
      this.getDepot()
    }
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      loading: true,
      form: {
        name: '',
        area_id: null,
        ptv_integration: false,
        ptv_url: '',
        ptv_username: '',
        ptv_password: '',
        ptv_project: '',
        ptv_profile: ''
      }
    }
  },

  methods: {
    async getDepot () {
      try {
        const { data } = await this.$api.get(`/account/${this.$route.params.account}/depots/${this.$route.params.id}`)
        this.form = data.depot
        this.loading = false
      } catch (error) {
        this.$toasted.error('There was a problem fetching this depot.')
        console.error(error)
      }
    },

    async upsertDepot () {
      try {
        this.submitting = true
        if (this.$route.params.id) {
          await this.$api.patch(`/account/${this.$route.params.account}/depots/${this.$route.params.id}`, this.form)
        } else {
          await this.$api.post(`/account/${this.$route.params.account}/depots/`, this.form)
        }
        this.$toasted.show(`Depot "${this.form.name}" ${this.$route.params.id ? 'Updated' : 'Created'}`)
        this.$router.push({ name: 'DepotList' })
      } catch (error) {
        this.$toasted.error('There was a problem saving this depot.')
        console.error(error)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>